var app = angular.module('leonardo');

var DocumentListFiles = function ($scope, $q, FolderFileService, $state, FilterService, $controller, PermissionService, $timeout, AttachmentService) {
  $scope.folderFileService = FolderFileService;
  $scope.permissionService = PermissionService;
  $scope.attachmentService = AttachmentService;
  $scope.showPath = false;
  $scope.tableFilterSize = 20;
  $scope.loadingFiles = false;

  $scope.getParamsFiles = function () {
    var documentStatus = FilterService.getFilter('document_status');
    var filters = {
      account: FilterService.getFilter('account_reports'),
      managed_by_reports: FilterService.getFilter('managed_by_reports'),
      portfolio: FilterService.getFilter('portfolio_reports'),
      property: FilterService.getFilter('property_reports'),
      name: FilterService.getFilter('search'),
      sector: $scope.getSector(),
      roles: FilterService.getFilter('role'),
      type: FilterService.getFilter('document_type')
    };
    if (documentStatus) {
      filters[documentStatus] = true;
    }
    if ($state.params.pk) {
      if (FilterService.hasFilter('search')) {
        filters['search_in_folder'] = $state.params.pk;
      } else {
        filters['folder'] = $state.params.pk;
      }
    } else {
      switch ($scope.mode) {
        case 'normal':
          filters['root_type_tree'] = 'library';
          break;
        case 'property':
          filters['root_type_tree'] = 'setup_property';
          break;
        case 'portfolio':
          filters['root_type_tree'] = 'setup_portfolio';
          break;
        case 'account':
          filters['root_type_tree'] = 'setup_account';
          break;
      }
    }
    return filters;
  };

  $scope.getEntitiesPromise = function (options) {
    var defer = $q.defer();
    var paramsFiles = $scope.getParamsFiles();
    angular.forEach(options, function (value, key) {
      paramsFiles[key] = value;
    });
    $scope.files = [];
    $scope.showPath = FilterService.hasFilter('search');
    if ($scope.showPath || $state.params.pk) {
      $scope.loadingFiles = true;
      if($state.params['from-mail'])
      {
        paramsFiles['ordering'] = '-created';
      }
      FolderFileService.getlist(paramsFiles).then(
        function (data) {
          $scope.loadingFiles = false;
          $scope.files = data.results ? data.results : data;
          defer.resolve(data);
        },
        function (error) {
          $scope.loadingFiles = false;
          if (error.data && angular.isString(error.data.detail) && error.data.detail.startsWith('Invalid page')) {
            $scope.files = [];
          }
          defer.resolve($scope.files);
        }
      );
    }
    return defer.promise;
  };

  $scope.$on('folder-file:created', function () {
    $scope.loadPage($scope.page);
  });

  $scope.$on('folder-file:updated', function () {
    $scope.loadPage($scope.page);
  });

  $scope.$on('folder-file:deleted', function () {
    $scope.loadPage($scope.page);
  });

  $scope.$on('folder:created', function () {
    $scope.loadPage($scope.page);
  });

  $scope.$on('folder:updated', function () {
    $scope.loadPage($scope.page);
  });

  $scope.$on('folder:deleted', function () {
    $scope.loadPage($scope.page);
  });

  $scope.$on('filter-service:filter-changed', function ($event, key) {
    if (key === 'document_type' || key === 'document_status') {
      $scope.loadPage(1);
    }
  });

  $scope.$on('filter-service:filter-removed', function ($event, key) {
    if (key === 'document_type' || key === 'document_status') {
      $scope.loadPage(1);
    }
  });

  $controller('TableFilterController', { $scope: $scope });

  $timeout(function () {
    $scope.loadPage($scope.page);
  }, 0);
};

app.controller('DocumentListFiles', [
  '$scope',
  '$q',
  'FolderFileService',
  '$state',
  'FilterService',
  '$controller',
  'PermissionService',
  '$timeout',
  'AttachmentService',
  DocumentListFiles
]);
